import { createSelector } from 'reselect';
import { addItemSavingsBasketSelector } from 'selectors/testTarget/offers/addItemSavingsBasket/addItemSavingsBasketSelector';

const experienceSelector = createSelector(addItemSavingsBasketSelector, addItemSavingsBasket => addItemSavingsBasket.experience);

export { experienceSelector };
